import { useSelector } from "react-redux";
import React from "react";
import "./RenderUpdatedCopy.css";
import { Tooltip } from "antd";
import dayjs from "../../../utils/dayjs";
import { daysJsFormat } from "../../../utils/constants";

// RenderUpdatedCopy component, responsible for rendering children
// and updating them based on Redux state changes.
export const RenderUpdatedCopy = ({ children, changesKey, data }) => {
  // Obtain necessary data from the Redux state
  const { prestation } = useSelector(state => state.prestation);

  // Extend the data object to include the changesKey for later use in children
  const extendedData = { ...data, dataKey: changesKey };

  // Clone original children and inject extended data and a basic React key
  const originalChildren = React.cloneElement(children, {
    key: `${changesKey}-basic`,
    ...extendedData,
  });

  // Check if the Redux state includes changes for the specified changesKey
  if (Object.keys(prestation?.changes || {}).includes(changesKey)) {
    const {
      originalValue,
      changeAt,
      needsApproval = false,
    } = prestation.changes[changesKey];

    // Create a props object that contains updated values
    const updatedProps = {
      [changesKey]: originalValue || "Donnée vide",
      dataKey: changesKey,
    };

    // Clone children with updated props and CSS class for indicating updates
    const updatedChildren = React.cloneElement(children, {
      key: `${changesKey}-updated`,
      className: `${children.props.className || ""} updated-class ${
        needsApproval ? "needsApproval" : ""
      }`,
      ...updatedProps,
    });

    // Render both original and updated children
    return (
      <Tooltip
        placement="topLeft"
        title={`Modifié le : ${dayjs(changeAt).format(daysJsFormat.full)}`}
      >
        {originalChildren}

        {updatedChildren}
      </Tooltip>
    );
  }

  // Render just the original children if no updates are present
  return originalChildren;
};
